import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { openFormApi, submitFormApi } from "../../../Api";
import { getDisclaimerHtml } from "../../../Functions";

const FormContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  maxHeight: "80vh",
  boxSizing: "border-box",
  padding: theme.spacing(3),
  boxShadow: "0px 0px 50px 0px rgba(7, 14, 39, 0.1)",
  backgroundColor: "#fff",
  display: "flex",
  flexDirection: "column",
}));
const Header = styled(Typography)(({ theme }) => ({
  font: "normal normal 600 24px Open Sans",
  textAlign: "center",
  width: "100%",
  marginBottom: theme.spacing(2),
  variant: "h6",
  component: "span",

  [[theme.breakpoints.between("xs", "sm")]]: {
    font: "normal normal 600 16px Open Sans",
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    font: "normal normal 600 16px Open Sans",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 600 20px Open Sans",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 600 24px Open Sans",
  },
}));

const HeaderWrapper = styled(Box)(({ theme }) => ({
  position: "sticky",
  top: 0,
  backgroundColor: "white",
  zIndex: 2,
}));
const ButtonWrapper = styled(Box)(({ theme }) => ({
  position: "sticky",
  bottom: 0,
  backgroundColor: "white",
  paddingTop: theme.spacing(2),
  zIndex: 2,
  width: "100%",
}));
const InputContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
}));
const FieldsWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: "auto",
  paddingTop: "12px",
  paddingBottom: "12px",
  paddingRight: "4px",
}));

const FieldWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));
const ThankYouWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: theme.spacing(2),
  minHeight: "70vh",
}));
const ThankYouMessage = styled(Typography)(({ theme }) => ({
  font: "normal normal 600 24px Poppins",
  whiteSpace: "pre-line",
  textAlign: "left",
  color: "#353535",
  vaiant: "h6",
  component: "p",
}));
const Label = styled(Typography)(({ theme }) => ({
  font: "normal normal 400 12px Poppins",
  color: "#040807",
  variant: "body1",
  component: "span",
  [[theme.breakpoints.between("xs", "md")]]: {
    font: "normal normal 400 12px Poppins",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 400 12px Poppins",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 400 14px Poppins",
  },
}));

const DescText = styled(Typography)(({ theme }) => ({
  font: "normal normal 400 12px Poppins",
  color: "#5a6066",
  variant: "body1",
  component: "span",
  [[theme.breakpoints.between("xs", "md")]]: {
    font: "normal normal 400 10px Poppins",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 400 10px Poppins",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 400 12px Poppins",
  },
}));

const OutlinedInputComponent = styled(OutlinedInput)(({ theme }) => ({
  lineHeight: "16px",
  margin: 0,
  fontSize: "16px",
  color: "#7c7d7c",
  borderColor: "#bbbbbb",
  border: "1px solid rgba(0, 0, 0, 0.1)",
  width: "100%",
  backgroundColor: "#fff",
  height: "40px",
  ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
    padding: "7px 16px",
  },
}));

const SelectComponent = styled(Select)(({ theme }) => ({
  padding: `0px`,
  margin: 0,
  fontSize: "16px",
  borderColor: "#bbbbbb",
  border: "1px solid rgba(0, 0, 0, 0.1)",
  width: "100%",
  backgroundColor: "#fff",
  ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select":
  {
    minHeight: "0px",
  },
}));

const DisclaimerWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  columnGap: "10px",
  width: "100%",
  marginBottom: theme.spacing(2),
}));

const SubHeader = styled(Typography)(({ theme }) => ({
  font: "normal normal 500 12px Open Sans",
  textAlign: "left",
  color: "#353535",
  variant: "caption",
  component: "span",
  [[theme.breakpoints.between("xs", "md")]]: {
    font: "normal normal 500 8px Open Sans",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 500 10px Open Sans",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 500 12px Open Sans",
  },
}));

const CountryCode = styled(Typography)(({ theme }) => ({
  font: "normal normal 400 14px Open Sans",
  textAlign: "center",
  color: "#5a6066",
  vaiant: "h6",
  component: "p",
}));

const FormComponent = ({ formState, contentState, primaryColor }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const [details, setDetails] = useState({});
  const [isCheckedDisclaimer, setIsCheckedDisclaimer] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const getLabelName = (meta) => {
    if (meta["required"] === true) {
      return `${meta["label"]}*`;
    } else {
      return meta["label"];
    }
  };

  const handleSubmit = async () => {
    let formData = { payload: { ...details } };
    if (details.hasOwnProperty("phone")) {
      formData["payload"]["phone"] = `+91-${details["phone"]}`;
    }
    if (details.hasOwnProperty("phone")) {
      formData["target"] = `+91-${details["phone"]}`;
    } else if (details.hasOwnProperty("email")) {
      formData["target"] = details["email"];
    } else {
      formData["target"] = "";
    }
    let response = await submitFormApi({
      formID: queryParams.get("form_id"),
      payload: formData,
    });
    setIsSubmitted(true);
  };

  const handleChange = (event) => {
    setDetails({ ...details, [event.target.name]: event.target.value });
  };

  useEffect(() => {
    openFormApi({ formID: queryParams.get("form_id") });
  }, []);

  return (
    <>
      <FormContainer>

        {!isSubmitted ?
          <>
            <HeaderWrapper>
              <Header
                sx={{
                  color: primaryColor,
                }}
              >
                {contentState.form_title}
              </Header>
            </HeaderWrapper>
            <InputContainer
              component="form"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <FieldsWrapper>
                <Grid container spacing={2}>
                  {formState.map((fieldMeta, index) => {
                    if (fieldMeta["field_type"] === "dropdown") {
                      return (
                        <Grid item xs={12} sm={12} md={12}>
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                              <DescText>{fieldMeta.desc}</DescText>}
                            <SelectComponent
                              name={fieldMeta["field_name"]}
                              fullWidth
                              required={fieldMeta["required"]}
                              input={
                                <OutlinedInputComponent
                                  required={fieldMeta["required"]}
                                />
                              }
                              displayEmpty
                              MenuProps={{
                                disableScrollLock: true,
                              }}
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              onChange={handleChange}
                              disabled={isSubmitted}
                            >
                              {fieldMeta["inputs"].map((item) => {
                                return <MenuItem value={item}>{item}</MenuItem>;
                              })}
                            </SelectComponent>
                          </FieldWrapper>
                        </Grid>
                      );
                    } else if (fieldMeta["field_type"] === "text") {
                      return (
                        <Grid item xs={12} sm={12} md={12}>
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                              <DescText>{fieldMeta.desc}</DescText>}
                            <OutlinedInputComponent
                              required={fieldMeta["required"]}
                              placeholder={fieldMeta["label"]}
                              type="text"
                              name={fieldMeta["field_name"]}
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              onChange={handleChange}
                              disabled={isSubmitted}
                            />
                          </FieldWrapper>
                        </Grid>
                      );
                    } else if (fieldMeta["field_type"] === "integer") {
                      return (
                        <Grid item xs={12} sm={12} md={12}>
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                              <DescText>{fieldMeta.desc}</DescText>}
                            <OutlinedInputComponent
                              required={fieldMeta["required"]}
                              placeholder={fieldMeta["label"]}
                              type="number"
                              name={fieldMeta["field_name"]}
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              onChange={handleChange}
                              disabled={isSubmitted}
                            />
                          </FieldWrapper>
                        </Grid>
                      );
                    } else if (fieldMeta["field_type"] === "phone") {
                      return (
                        <Grid item xs={12} sm={12} md={12}>
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                              <DescText>{fieldMeta.desc}</DescText>}
                            <OutlinedInputComponent
                              required={fieldMeta["required"]}
                              placeholder={fieldMeta["label"]}
                              inputProps={{
                                inputMode: "numeric",
                                pattern: "^[0-9]{10}$",
                                maxLength: 10,
                              }}
                              name={fieldMeta["field_name"]}
                              startAdornment={
                                <InputAdornment position="start">
                                  <CountryCode>+91</CountryCode>
                                </InputAdornment>
                              }
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              onChange={handleChange}
                              disabled={isSubmitted}
                            />
                          </FieldWrapper>
                        </Grid>
                      );
                    } else if (fieldMeta["field_type"] === "email") {
                      return (
                        <Grid item xs={12} sm={12} md={12}>
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                              <DescText>{fieldMeta.desc}</DescText>}
                            <OutlinedInputComponent
                              required={fieldMeta["required"]}
                              placeholder={fieldMeta["label"]}
                              name={fieldMeta["field_name"]}
                              type="email"
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              onChange={handleChange}
                              disabled={isSubmitted}
                            />
                          </FieldWrapper>
                        </Grid>
                      );
                    }
                  })}
                </Grid>
              </FieldsWrapper>
              <ButtonWrapper>
                <DisclaimerWrapper>
                  <FormControlLabel
                    disabled={isSubmitted}
                    sx={{
                      alignItems: "flex-start",
                      margin: 0,
                    }}
                    onChange={() => {
                      setIsCheckedDisclaimer(!isCheckedDisclaimer);
                    }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={isCheckedDisclaimer}
                        sx={{
                          paddingTop: "0px",
                        }}
                      />
                    }
                    label={
                      <Box
                        sx={{
                          fontSize: "12px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                          color: "#353535",
                          margin: 0,
                          "& p": {
                            fontFamily: "inherit",
                            fontWeight: "inherit",
                            fontSize: "inherit",
                            margin: 0,
                          },
                          "& div": {
                            margin: 0,
                          },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: getDisclaimerHtml(contentState.disclaimer),
                        }}
                      />
                    }
                  />
                </DisclaimerWrapper>
                <Button
                  disabled={!isCheckedDisclaimer || isSubmitted}
                  variant="contained"
                  fullWidth
                  type="submit"
                  style={{
                    textTransform: "none",
                    color: "white",
                    font: "normal normal 700 16px open sans",
                  }}
                >
                  SUBMIT
                </Button>
              </ButtonWrapper>
            </InputContainer>
          </>
          :
          <ThankYouWrapper>
            <ThankYouMessage>{contentState.thankyou_message}</ThankYouMessage>
          </ThankYouWrapper>}
      </FormContainer>
    </>
  );
};

export default FormComponent;
